import type { MRT_ColumnDef } from "mantine-react-table-open";
import type { SiteOverviewSite, SiteStatusSite } from "../../site-status-types";
import { DataAssessmentCell, DataAssessmentState } from "./DataAssessmentCell";

function getDataSufficientBaseColumn(): Pick<
  MRT_ColumnDef<SiteOverviewSite | SiteStatusSite>,
  | "Cell"
  | "filterVariant"
  | "mantineFilterMultiSelectProps"
  | "filterFn"
  | "enableGlobalFilter"
> {
  return {
    Cell: ({ cell, row }) => (
      <DataAssessmentCell
        assessment={cell.getValue<boolean>()}
        projectId={row.original.projectId}
      />
    ),
    enableGlobalFilter: false,
    filterVariant: "multi-select",
    mantineFilterMultiSelectProps: {
      data: Object.values(DataAssessmentState)
    },
    filterFn: (row, columnId, filterValue) => {
      if (filterValue.length === 0) {
        return true;
      }

      const assessment = row.getValue(columnId) ?? null;

      if (
        assessment === true &&
        filterValue.includes(DataAssessmentState.Sufficient)
      ) {
        return true;
      }
      if (
        assessment === false &&
        filterValue.includes(DataAssessmentState.NotSufficient)
      ) {
        return true;
      }
      if (
        assessment === null &&
        filterValue.includes(DataAssessmentState.None)
      ) {
        return true;
      }
      return false;
    }
  };
}

export { getDataSufficientBaseColumn };
